'use client'

import { useTranslations } from 'next-intl'

import { Cityscape } from '@/shared/asset'
import { useSession } from '@/shared/lib'
import { Layout } from '@/shared/ui'

import './banner.css'

export const Banner = () => {
  const { data } = useSession()

  const t = useTranslations('help_center')

  const name = data?.name

  return (
    <section className="support-banner-gradient">
      <Layout className="my-0 mt-15 flex h-55 justify-between">
        <div className="typo-display2 mt-5 flex h-30 flex-col justify-center text-black">
          {name && (
            <span className="font-light">{t('hero.greeting', { name })}</span>
          )}
          <h2 className="font-bold">{t('hero.title')}</h2>
        </div>
        <Cityscape className="self-end" width={416} />
      </Layout>
    </section>
  )
}
